<ng-container *ngIf="data.formControlName; else ngModelTemplate">
    <!-- Renderiza dentro do formGroup -->
    <div [formGroup]="parentForm">
        <ng-container [ngSwitch]="data.field">
            <!-- Input de texto (padrão) -->
            <input *ngSwitchCase="'text'" [type]="data.type" [placeholder]="data.placeholder"
                [formControlName]="data.formControlName" [mask]="data.mask" (ionInput)="onInputChange($event)" />

            <!-- Textarea -->
            <ion-textarea *ngSwitchCase="'textarea'" [placeholder]="data.placeholder"
                [formControlName]="data.formControlName" [rows]="data.rows || 3" [cols]="data.cols || 30"
                (ionInput)="onInputChange($event)">
            </ion-textarea>

            <!-- Select -->
            <ion-select mode="ios" *ngSwitchCase="'select'" [formControlName]="data.formControlName" [placeholder]="data.placeholder" (ionChange)="onInputChange($event)">
                <ion-select-option *ngFor="let option of data.options" [value]="option.value">
                    {{option.label}}
                </ion-select-option>
            </ion-select>

            <!-- Checkbox -->
            <ion-item *ngSwitchCase="'checkbox'">
                <ion-checkbox mode="ios" slot="start" [formControlName]="data.formControlName"
                    (ionChange)="onInputChange($event)">
                </ion-checkbox>
                <ion-label>{{data.label}}</ion-label>
            </ion-item>

            <!-- DateTime Picker -->
            <app-datetime-picker *ngSwitchCase="'datetime'"
                [value]="parentForm.get(data.formControlName!)?.value || ''"
                [placeholder]="data.placeholder || 'Selecione data e horário'"
                [buttonStyles]="buttonStyles"
                (valueChange)="onDateTimeChange($event)">
            </app-datetime-picker>

            <!-- Caso padrão -->
            <input *ngSwitchDefault [type]="data.type" [placeholder]="data.placeholder"
                [formControlName]="data.formControlName" [mask]="data.mask" (ionInput)="onInputChange($event)" />
        </ng-container>
    </div>
</ng-container>

<!-- Template com ngModel -->
<ng-template #ngModelTemplate>
    <ng-container [ngSwitch]="data.field">
        <!-- Input de texto (padrão) -->
        <input *ngSwitchCase="'text'" [type]="data.type" [placeholder]="data.placeholder" [(ngModel)]="data.value"
            [mask]="data.mask" (ionInput)="onInputChange($event)" />

        <!-- Textarea -->
        <ion-textarea *ngSwitchCase="'textarea'" [placeholder]="data.placeholder" [(ngModel)]="data.value"
            [rows]="data.rows || 3" [cols]="data.cols || 30" (ionInput)="onInputChange($event)">
        </ion-textarea>

        <!-- Select -->
        <ion-select mode="ios" *ngSwitchCase="'select'" [(ngModel)]="data.value" [placeholder]="data.placeholder" (ionChange)="onInputChange($event)">
            <ion-select-option *ngFor="let option of data.options" [value]="option.value">
                {{option.label}}
            </ion-select-option>
        </ion-select>

        <!-- Checkbox -->
        <ion-item *ngSwitchCase="'checkbox'">
            <ion-checkbox mode="ios" slot="start" [(ngModel)]="data.value" (ionChange)="onInputChange($event)">
            </ion-checkbox>
            <ion-label>{{data.label}}</ion-label>
        </ion-item>

        <!-- Caso padrão -->
        <input *ngSwitchDefault [type]="data.type" [placeholder]="data.placeholder" [(ngModel)]="data.value"
            [mask]="data.mask" (ionInput)="onInputChange($event)" />
    </ng-container>
</ng-template>
